import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../shared/models/response.model';
import { Activité } from './models/activité.model';
import { ActiviteCreateRequest } from './activité-form/requests/create-request';
import { ActiviteUpdateRequest } from './activité-form/requests/update-request';
import { ActiviteDuplicateRequest } from './activité-form/requests/duplicate-request';

@Injectable({
  providedIn: 'root',
})
export class ActivitéService {
  #http = inject(HttpClient);
  readonly BASE_URL = '/activités';

  trouveParId(idSequence: string) {
    return this.#http.get<Activité>(this.BASE_URL + '/' + idSequence);
  }

  trouverTous(nom: string, idReferentiel?: string | null) {
    let params = new HttpParams().append('nom', nom);

    if (idReferentiel) params = params.append('idReferentiel', idReferentiel);

    return this.#http.get<Response<Activité>>(this.BASE_URL, { params });
  }

  ajouter(data: ActiviteCreateRequest) {
    return this.#http.post<Activité>(this.BASE_URL, data);
  }

  dupliquer(data: ActiviteDuplicateRequest) {
    return this.#http.post<Activité>(this.BASE_URL + '/dupliquer', data);
  }

  modifier(id: string, data: ActiviteUpdateRequest) {
    return this.#http.put<Activité>(this.BASE_URL + '/' + id, data);
  }
}
